import React from "react";
import {useWizard} from "store/wizard";

const Steps = (props) => {
   const wizard = useWizard();
   const _steps = wizard.steps.filter((i) => i.type == wizard.type)[0];
   return (
      <>
         <div className="wizard flex flex-col lg:flex-row justify-center px-5">
            {_steps &&
            _steps.steps.length > 0 &&
            _steps.steps.map((item) => (
               <div className="intro-x lg:text-center flex items-center lg:block flex-1 z-10">
                  <button
                     onClick={() => {
                        if (wizard.mode && wizard.mode == 'update') {
                           wizard.dispatch(wizard.changeStep(item.step));
                        }
                     }}
                     className={`w-10 h-10 rounded-full btn ${
                        item.step == wizard.step
                           ? "btn-primary"
                           : "text-gray-600 bg-gray-200 dark:bg-dark-1"
                     }`}
                  >
                     {item.step}
                  </button>
                  <div className="lg:w-32 font-medium text-base lg:mt-3 ml-3 lg:mx-auto">
                     {item.label}
                  </div>
               </div>
            ))}
            <div className=" wizard__line hidden lg:block w-full bg-gray-200 dark:bg-dark-1 absolute mt-5"></div>
         </div>
      </>
   );
};

export default Steps;
